import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { createQueryClient } from './api/query-client';
import { AppProviders } from './app/providers';
import { createAppRouter } from './app/routes';
import './styles/index.css';

const container = document.getElementById('root');
if (container === null) {
  throw new Error('В index.html нет элемента #root');
}

// Кэш запросов и роутер — по одному на вкладку: роутер берёт кэш в корневой загрузчик (кто вошёл).
const queryClient = createQueryClient();
const router = createAppRouter(queryClient);

createRoot(container).render(
  <StrictMode>
    <AppProviders queryClient={queryClient} router={router} />
  </StrictMode>,
);
